/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/* ==============================================================
   Interactive Heat / Landing
============================================================== */
let intHeatLabels = document.querySelectorAll('.section__interactive-heat__label');
let mainImages = document.querySelectorAll('.section__interactive-heat__main-image');
let hoverImages = document.querySelectorAll('.section__interactive-heat__hover-image');
let thermometerImages = document.querySelectorAll('.section__interactive-heat__thermometer-image');
let toRemoveVariants = document.querySelectorAll('[js-bundle-product-quantity]');

function handleHeadLabel(ih) {
  const activeElement = document.querySelector('.section__interactive-heat__label.active');
    const activeMainImage = document.querySelector(`[data-block-id="${ih.dataset.blockId}"].section__interactive-heat__main-image`);
    const activeThermometerImage = document.querySelector(`[data-block-id="${ih.dataset.blockId}"].section__interactive-heat__thermometer-image`);

    if (activeElement) {
      activeElement.classList.remove('active');
      mainImages.forEach((mi) => {
        mi.setAttribute('hidden', '');
      });
      hoverImages.forEach((hi) => {
        hi.setAttribute('hidden', '');
      });
      thermometerImages.forEach((ti) => {
        ti.setAttribute('hidden', '');
      });
    }

    ih.classList.add('active');
    activeMainImage.removeAttribute('hidden');
    if (activeThermometerImage) {
      activeThermometerImage.removeAttribute('hidden');
    }
}

function handleMainImage(mi) {
  const hoverImage = document.querySelector(`[data-block-id="${mi.dataset.blockId}"].section__interactive-heat__hover-image`)
  if (hoverImage) {
    mi.setAttribute('hidden', '');
    hoverImage.removeAttribute('hidden');
  }
}

function handledHoverImage(hi) {
  const mainImage = document.querySelector(`[data-block-id="${hi.dataset.blockId}"].section__interactive-heat__main-image`)

  if (mainImage) {
    hi.setAttribute('hidden', '');
    mainImage.removeAttribute('hidden');
  }
}

intHeatLabels.forEach((ih) => {
  ih.addEventListener('mouseover', function () {
    handleHeadLabel(ih);
  });
  ih.addEventListener('click', function () {
    handleHeadLabel(ih);
  });
});

// mainImages.forEach((mi) => {
//   mi.addEventListener('mouseover', function () {
//     handleMainImage(mi);
//   });
// });

// hoverImages.forEach((hi) => {
//   hi.addEventListener('mouseleave', function () {
//     handledHoverImage(hi);    
//   });
// });

/* ==============================================================
   Bundle Product
============================================================== */

let sessionBundleStacks = [];
let selectedPacks = 4;
const bundleItems = document.querySelectorAll('.bundle-builder__bundle-item');
const bundleCloseBtn = document.querySelectorAll('.bundle-builder__bundle-item-close');
const bundleOptions = document.querySelectorAll('.bundle-builder__option label');
const addToBundles = document.querySelectorAll('.add-to-bundle');
const addToCart = document.querySelector('.build-builder__atc');
const packOptions = document.querySelectorAll('.popover__choice-item');
let pricePack = {
  price: 0,
  comparePrice: 0,
};
let packIndexes = [0,1,2,3,4];

// Clear status for the removed bundle item
function removeBundleItem(element) {
  if (!element) return;
  pricePack.price = (pricePack.price - (element.dataset.price / 100)).toFixed(2);
  pricePack.comparePrice = (pricePack.comparePrice - (element.dataset.comparePrice / 100)).toFixed(2);

  element.classList.remove('filled');
  element.style.backgroundImage = null;
  element.dataset.price = 0;
  element.dataset.comparePrice = 0;
  packIndexes.unshift(parseInt(element.dataset.index));
  packIndexes = packIndexes.sort();
}

// Add to cart handler with cart.js
function addToBundle(bundleData) {
  addToCart.setAttribute('aria-busy', 'true');
  let cartData = {
    'sections': {
      'mini-cart': null
    }
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(bundleData)
  })
  .then(response => {
    fetch('/cart?section_id=mini-cart').then(res => res.text()).then( r => {
      cartData['sections']['mini-cart'] = r;

      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartData,
          openMiniCart: true,
        }
      }));
    })
    addToCart.removeAttribute('aria-busy');

    return response.json()
  })
  .then(res => {
    let itemsCount = 0;

    res.items.forEach(item => {
      itemsCount += item.quantity;
    });
    cartData['item_count'] = itemsCount;

    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
      bubbles: true,
      detail: {
        cart: cartData,
        openMiniCart: false,
      }
    }));
  })
  .catch((error) => {
    console.error('Error:', error);
  })
}

// Get Duplicated bundle items 
function count_duplicate(a) {
  let bundleData = {
    'items': []
  }
  let counts = {}

 for(let i =0; i < a.length; i++){ 
    if (counts[a[i]]){
      counts[a[i]] += 1
    } else {
     counts[a[i]] = 1
    }
  }  
  for (let prop in counts){
    if (counts[prop] >= 2){
      bundleData['items'].push({
        'id': prop,
        'quantity': counts[prop],
        'properties': {
          '_timestamp': Date.now(),
        }
      })
    } else {
      bundleData['items'].push({
        'id': prop,
        'quantity': 1,
        'properties': {
          '_timestamp': Date.now(),
        }
      });
    }
  }

  return bundleData;
}

// Add to cart handler for bundle page template
if (window.location.href.indexOf('/pages/shop-bundle') > 0) {
  addToCart.addEventListener('click', () => {
    let draft = [];
  
    bundleItems.forEach((bi) => {
      if (bi.classList.value.indexOf('filled') >= 0) {
        draft.push(`${bi.dataset.variantId}`)
      }
    });
  
    addToBundle(count_duplicate(draft));
  });
}

// Price handler for pack options
packOptions.forEach((po) => {
  po.addEventListener('click', () => {
    const filledItems = document.querySelectorAll('.bundle-builder__bundle-item.filled');
    const pack5Items = document.querySelectorAll('[data-pack="5-pack"]');
    const pack4Items = document.querySelectorAll('[data-pack="4-pack"]');
    const pack4Price = document.querySelector('.bundle-builder__price-4');
    const pack5Price = document.querySelector('.bundle-builder__price-5');

    selectedPacks = parseInt(po.dataset.value);

    if (filledItems.length >= selectedPacks) {
      addToCart.removeAttribute('disabled');
    } else {
      addToCart.setAttribute('disabled', '');
    }

    if (po.dataset.value == '4') {
      for (let i=0;i<5;i++) {
        const filledItem = document.querySelector(`.bundle-builder__bundle-item.filled[data-index="${i}"]`);
        removeBundleItem(filledItem);
      }
      packIndexes = [0,1,2,3,4];

      pack5Items.forEach((p5) => p5.classList.add('hidden'));
      pack4Items.forEach((p4) => p4.classList.remove('hidden'));

      pack4Price.innerHTML = `
        <span class="stroke" data-value="0">$${pricePack.price}</span>
        <span class="price" data-value="0">$${pricePack.comparePrice}</span>
      `;

      pack5Price.innerHTML = `
        <span class="stroke" data-value="0">$0.00</span>
        <span class="price" data-value="0">$0.00</span>
      `;
    } else {
      for (let i=0;i<4;i++) {
        const filledItem = document.querySelector(`.bundle-builder__bundle-item.filled[data-index="${i}"]`);
        removeBundleItem(filledItem);
      }
      packIndexes = [0,1,2,3,4];

      pack4Items.forEach((p4) => p4.classList.add('hidden'));
      pack5Items.forEach((p5) => p5.classList.remove('hidden'));

      pack5Price.innerHTML = `
        <span class="stroke" data-value="0">$${pricePack.price}</span>
        <span class="price" data-value="0">$${pricePack.comparePrice}</span>
      `;

      pack4Price.innerHTML = `
        <span class="stroke" data-value="0">$0.00</span>
        <span class="price" data-value="0">$0.00</span>
      `;
    }
  });
})

// Pack option handler
bundleOptions.forEach((bo) => {
  bo.addEventListener('click', () => {
    if (bo.dataset.value == 5) {
      bundleItems.forEach((bi) => {
        bi.classList.remove('hidden');
      });
    } else {
      bundleItems[4].classList.add('hidden');
    }
  });
});

// Remove bundle item handler
bundleCloseBtn.forEach((bcs) => {
  bcs.addEventListener('click', () => {
    const filledItems = document.querySelectorAll('.bundle-builder__bundle-item.filled');
    let packPriceElement = document.querySelector('.bundle-builder__price-5');
    bcs.parentElement.classList.remove('filled');
    bcs.parentElement.style.backgroundImage = null;
    packIndexes.unshift(parseInt(bcs.parentElement.dataset.index));
    packIndexes = packIndexes.sort();

    pricePack.price = (parseFloat(pricePack.price) - parseFloat(bcs.parentElement.dataset.price) / 100).toFixed(2);
    pricePack.comparePrice = (parseFloat(pricePack.comparePrice) - parseFloat(bcs.parentElement.dataset.comparePrice) / 100).toFixed(2);

    bcs.parentElement.dataset.price = 0;
    bcs.parentElement.dataset.comparePrice = 0;

    if (selectedPacks == '4') {
      packPriceElement = document.querySelector('.bundle-builder__price-4');
    }
    packPriceElement.innerHTML = `
      <span class="stroke" data-value="0">$${pricePack.price}</span>
      <span class="price" data-value="0">$${pricePack.comparePrice}</span>
    `;

    if (filledItems.length <= selectedPacks) {
      addToCart.setAttribute('disabled', '');
    } else {
      addToCart.removeAttribute('disabled');
    }
  });
});

// a11y
// Find all iframe elements
const iframes = document.querySelectorAll('iframe');

for (const iframe of iframes) {
    if (!iframe.title.trim()) {
        iframe.title = '3rd party iFrame';
    }
}

console.log('ADA by Dan P.')

// Add to bundle handler
addToBundles.forEach((atb) => {
  atb.addEventListener('click', () => {
    const filledItems = document.querySelectorAll('.bundle-builder__bundle-item.filled');
    const pack4Price = document.querySelector('.bundle-builder__price-4');
    const pack5Price = document.querySelector('.bundle-builder__price-5');
    let availablePosItem = document.querySelector(`.bundle-builder__bundle-item[data-index="${packIndexes[0]}"]`);

    if (!availablePosItem || filledItems.length == selectedPacks) return;
    availablePosItem.style.backgroundImage = `url(${atb.dataset.productImage})`;
    availablePosItem.classList.add('filled');
    availablePosItem.dataset.variantId = atb.dataset.variantId;
    availablePosItem.dataset.price = atb.dataset.price;
    availablePosItem.dataset.comparePrice = atb.dataset.comparePrice;

    packIndexes.splice(packIndexes.indexOf(packIndexes[0]), 1);
    packIndexes = packIndexes.sort((a, b) => a - b);

    if (filledItems.length == selectedPacks - 1) {
      addToCart.removeAttribute('disabled');
    }

    if (selectedPacks == '4') {
      const stroke = pack4Price.querySelector('.stroke');
      const price = pack4Price.querySelector('.price');

      pricePack.price = (parseFloat(pricePack.price) + parseFloat(atb.dataset.price) / 100).toFixed(2);
      stroke.innerHTML = `$${pricePack.price}`;
      pricePack.comparePrice = (parseFloat(pricePack.comparePrice) + parseFloat(atb.dataset.comparePrice) / 100).toFixed(2);
      price.innerHTML = `$${pricePack.comparePrice}`;
    } 
    
    if (selectedPacks == '5') {
      const stroke = pack5Price.querySelector('.stroke');
      const price = pack5Price.querySelector('.price');

      pricePack.price = (parseFloat(pricePack.price) + parseFloat(atb.dataset.price) / 100).toFixed(2);
      stroke.innerHTML = `$${pricePack.price}`;
      pricePack.comparePrice = (parseFloat(pricePack.comparePrice) + parseFloat(atb.dataset.comparePrice) / 100).toFixed(2);
      price.innerHTML = `$${pricePack.comparePrice}`;
    }
  });
});

let updates = new Object();

function removeBundleWithChildItem(bundleId) {
  let cartData = {
    'sections': {
      'mini-cart': null
    }
  };

  toRemoveVariants = document.querySelectorAll(`[js-bundle-product-quantity][data-bundle-id="${bundleId}"]`);

  toRemoveVariants.forEach((tr) => {
    if (tr.dataset.variantId && tr.dataset.bundleId == bundleId) {
      updates[`${tr.dataset.variantId}`] = 0;
    }
  })

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      updates
    })
  })
  .then(response => {
    updates = {};

    fetch('/cart?section_id=mini-cart').then(res => res.text()).then( r => {
      cartData['sections']['mini-cart'] = r;

      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartData,
          openMiniCart: true,
        }
      }));
    })

    return response.json();
  })
  .then(res => {
    let itemsCount = 0;

    res.items.forEach(item => {
      itemsCount += item.quantity;
    });
    cartData['item_count'] = itemsCount;

    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
      bubbles: true,
      detail: {
        cart: cartData,
        openMiniCart: false,
      }
    }));
  })
  .catch((error) => {
    console.error('Error:', error);
  })

  return false;
}

function handleRemoveBundle(bundleId) {
  setTimeout(removeBundleWithChildItem(bundleId), 500);
}